/**
 * Sticky Buy Bar Web Component
 * Uses IntersectionObserver on the primary ATC button.
 * When ATC scrolls out of view, shows sticky bar at bottom of viewport (mobile only).
 * Sticky bar's ATC delegates to the main product form via requestSubmit().
 */
import { ABBaseComponent, defineComponent } from './ab-base-component.js';

class ABStickyBuyBar extends ABBaseComponent {
  connectedCallback() {
    this.atcButton = document.querySelector('.ab-product__atc');
    if (!this.atcButton) return;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.classList.toggle('ab-sticky-buy-bar--visible', !entry.isIntersecting);
      },
      { threshold: 0 }
    );
    this.observer.observe(this.atcButton);

    // Sticky bar ATC click delegates to main form
    const stickyAtc = this.$('.ab-sticky-buy-bar__atc');
    if (stickyAtc) {
      stickyAtc.addEventListener('click', (e) => {
        e.preventDefault();
        const mainForm = document.getElementById('product-form');
        if (mainForm) {
          mainForm.requestSubmit();
        }
      });
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.observer = null;
    this.atcButton = null;
  }
}

defineComponent('ab-sticky-buy-bar', ABStickyBuyBar);
